import api from "./axios";

const API_URL = "/chat";

export const sendMessage = (toUserId, text, userHistoryId = null, teamHistoryId = null, threadId = null) => {
  const params = {
    to_user_id: toUserId,
    text: text,
  };
  
  if (userHistoryId) params.user_history_id = userHistoryId;
  if (teamHistoryId) params.team_history_id = teamHistoryId;
  if (threadId) params.thread_id = threadId;
  
  return api.post(`${API_URL}/messages`, null, { params });
};

export const getChatHistory = (userId, limit = 50, threadId = null) => {
  const params = { limit };
  if (threadId) params.thread_id = threadId;
  
  return api.get(`${API_URL}/history/${userId}`, { params });
};

export const getChatThreads = () => {
  return api.get(`${API_URL}/threads`);
};

export const streamChatMessages = () => {
  const token = localStorage.getItem("token");
  const apiBase = process.env.VUE_APP_API_URL || "/api";
  const url = `${apiBase}${API_URL}/stream?token=${token}`;
  return new EventSource(url);
};
